<template>
  <force-landscape
    v-if="visible"
    style="background-color: #000000b5"
    :style="
      stageConfig.type == 1 ? 'pointer-events: none' : 'pointer-events: auto'
    "
    :forceLandscape="true"
  >
    <div class="font1">
      <div
        v-if="timecount < 1"
        style="text-align: center; margin-top: 1%"
        :style="{ height: curHeight + 'px' }"
      >
        <div
          class="bg"
          :style="{backgroundImage: bgURL}"
        ></div>

        <!-- 开始挑战 -->
        <div
          @click="startCountdown()"
          class="startButton"
          style="pointer-events: auto"
        >
          <div>{{ buttonText }}</div>
        </div>
      </div>

      <!-- 倒计时框 -->
      <div
        v-if="timecount >= 1"
        style="text-align: center; height: 100%;"
      >
        <div class="timetext">{{ timecount }}</div>
      </div>
    </div>
  </force-landscape>
</template>
<script>
import ForceLandscape from "../../../components/layout/ForceLandscape.vue";
import { LANG } from "@/constant";
import coverURLzh from "@/assets/hok/dialog_cover_en.png";
import coverURLmy from "@/assets/hok/dialog_cover_my.png";
import coverURLid from "@/assets/hok/dialog_cover_id.png";

export default {
  components: {
    ForceLandscape,
  },

  data() {
    return {
      title: "",
      buttonText: "",
      visible: false,
      needForceLandscape: false,
      url: "",
      type: 1, // 1残局 2兵海挑战
      timecount: -1,
      timer: [],
      stageConfig: {},
      curHeight: Math.min(window.innerHeight, window.innerWidth),
      bgURL: "",
    };
  },
  mounted() {
    this.initBg();
    window.addEventListener("resize", this.handleWindowChange);
  },
  methods: {
    initBg() {
      switch (LANG) {
        case "id":
          this.bgURL = `url(${coverURLid})`;
          break;
        case "my":
          this.bgURL = `url(${coverURLmy})`;
          break;
        default:
          this.bgURL = `url(${coverURLzh})`;
          break;
      }
    },
    getMessage(value) {
      console.log(value);
    },

    exitgame() {
      this.visible = false;
    },

    startCountdown() {
      if (!window.cg.game.isFullscreen()) {
        window.cg.game.fullscreen();
      }
      this.timecount = 3;
      this.timer[0] = setInterval(this.countDown, 1000);
    },

    countDown() {
      if (this.timecount > 1) {
        this.timecount -= 1;
      } else {
        this.visible = false;
        this.timecount = -1;
        this.startgame();
      }
    },

    startgame() {
      clearInterval(this.timer[0]);
      this.visible = false;
    },
    jumpToPolicy(url) {
      this.$defaultIframe.open({
        needForceLandscape: true,
        url: url,
      });
    },
    handleWindowChange() {
      this.curHeight = Math.min(window.innerHeight, window.innerWidth);

      console.log("innerHeight", this.curHeight);
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleWindowChange);
  },
};
</script>
<style lang="less" scoped>
.font1 {
  font-family: "Radikal Medium";
  height: 100%;
}
.title {
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #fff0bd;
  display: inline-block;
  margin: 0 2vmin;
  text-shadow: 0px 0px 20px rgba(71, 41, 21, 0.77), 0px 0px 5px orange,
    0px 0px 5px orangered, 0px 0px 10px rgba(71, 41, 21, 0.77);
}

.bg {
  position: relative;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
  top: 20%;
  left: 50%;
  transform: translate(-50%, -20%);
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.startButton {
  color: white;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0%);
  bottom: 10vmin;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 15px;
  padding: 2vmin 10vmin;
  min-width: 20vmin;
  height: 4vmin;
  background-image: url(../../../assets/hok/start_btn.png);
  background-size: 100% 100%;
  z-index: 6;
}

.leftarrow {
  background-image: url(../../../assets/hok/huawenzuo.png);
  background-size: 100% 100%;
  display: inline-block;
  width: 22vmin;
  height: 4vmin;
}

.rightarrow {
  background-image: url(../../../assets/hok/huawenyou.png);
  background-size: 100% 100%;
  display: inline-block;
  width: 22vmin;
  height: 4vmin;
}

.exitimg {
  background-image: url("https://ct-global-dev-1300343054.cos.ap-singapore.myqcloud.com/mc/1675649327512TnypdBJTnH.png");
  background-size: 100% 100%;
  display: inline-block;
  width: 14vmin;
  height: 8vmin;
}

.exitbutton {
  position: fixed;
  left: 4vmin;
  top: 4vmin;
}

.timetext {
  font-size: 24vmin;
  color: rgb(255, 241, 195);
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.hint-wrap {
  font-size: 4vmin;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 80%;
}

.hint-item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
}
.policy-txt {
  font-size: 2vmin;
  font-weight: lighter;
  color: #bbc5d4;
  margin-top: 4vmin;
}
</style>
